import React, { useEffect } from 'react';
import { useProductDetails } from './hooks/ProductDetails.hook';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isMexico } from '@/helpers/locationHelpers';
import NewProductDetailsView from './views/NewProductDetailsView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const NewProductDetailController = () => {
  const location = useLocation();
  const { spaceData: spaceDataFromState } = location.state || {};
  const { idSubSpace } = useParams();
  const spaceId = spaceDataFromState?.id_relationship || idSubSpace;
  const currencyData = useSelector((state) => state.currency);
  const geolocation = useSelector((state) => state.location?.data);
  const isFromMexico = isMexico(geolocation);
  const { isLoading, spaceDetailInfo, commentsData } = useProductDetails(
    spaceId,
    currencyData,
    isFromMexico,
  );

  if (!spaceId || isLoading) {
    return <LoadingComponent loading={isLoading} />;
  } else {
    return <NewProductDetailsView spaceComments={commentsData} spaceDetail={spaceDetailInfo} />;
  }
};

export default NewProductDetailController;
